import { render, staticRenderFns } from "./CancelFreeOrderRoute.vue?vue&type=template&id=06df1c4a&"
import script from "./CancelFreeOrderRoute.vue?vue&type=script&lang=ts&"
export * from "./CancelFreeOrderRoute.vue?vue&type=script&lang=ts&"
import style0 from "./CancelFreeOrderRoute.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports